
import { useState } from 'react'
import { Bell, CheckCheck, RefreshCw, Filter } from 'lucide-react'
import { useNotificaciones } from '../../../hooks/useNotify'
import { NotificacionItem } from './NotificacionItem'

const MODULOS = [
    { value: '', label: 'Todos' },
    { value: 'presupuestos', label: 'Presupuestos' },
    { value: 'proyectos', label: 'Proyectos' },
    { value: 'tareas', label: 'Tareas' },
    { value: 'facturas', label: 'Facturas' },
    /* { value: 'finanzas', label: 'Finanzas' }, */
    { value: 'gastos', label: 'Gastos' },
    /*  { value: 'crm', label: 'CRM' }, */
]

export const Notificaciones = () => {
    const [moduloActivo, setModuloActivo] = useState('')
    const [soloNoLeidas, setSoloNoLeidas] = useState(false)

    const {
        notificaciones,
        noLeidas,
        loading,
        cargar,
        marcarLeida,
        marcarTodasLeidas,
        archivar
    } = useNotificaciones()

    const filtradas = notificaciones
        .filter(n => moduloActivo ? n.modulo === moduloActivo : true)
        .filter(n => soloNoLeidas ? !n.leida : true)

    return (
        <div className="">

            {/* Header */}
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-2">
                    <Bell className="w-5 h-5 text-[#595759]" />
                    <h1 className="text-lg font-semibold text-[#595759]">Notificaciones</h1>
                    {noLeidas > 0 && (
                        <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-[#8E24AA] text-white">
                            {noLeidas}
                        </span>
                    )}
                </div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => cargar()}
                        className="p-2 rounded-lg text-[#909090] hover:text-[#595759] hover:bg-[#F9F9F9] transition-colors"
                        title="Actualizar"
                    >
                        <RefreshCw className="w-4 h-4" />
                    </button>
                    {noLeidas > 0 && (
                        <button
                            onClick={marcarTodasLeidas}
                            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-[#8E24AA] 
                         border border-[#8E24AA]/30 rounded-lg hover:bg-[#FCF1FF] transition-colors"
                        >
                            <CheckCheck className="w-3.5 h-3.5" />
                            Marcar todas como leídas
                        </button>
                    )}
                </div>
            </div>

            {/* Filtros por módulo */}
            <div className="flex items-center gap-2 mb-4 overflow-x-auto pb-1">
                {MODULOS.map(m => (
                    <button
                        key={m.value}
                        onClick={() => setModuloActivo(m.value)}
                        className={`
              flex-shrink-0 px-3 py-1.5 text-xs font-medium rounded-full border transition-colors
              ${moduloActivo === m.value
                                ? 'bg-[#8E24AA] text-white border-[#8E24AA]'
                                : 'bg-white text-[#909090] border-[#EDEDED] hover:border-[#8E24AA]/30 hover:text-[#595759]'}
            `}
                    >
                        {m.label}
                    </button>
                ))}
            </div>

            {/* Filtro solo no leídas */}
            <div className="flex items-center gap-2 mb-5">
                <button
                    onClick={() => setSoloNoLeidas(!soloNoLeidas)}
                    className={`
            flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full border transition-colors
            ${soloNoLeidas
                            ? 'bg-[#FCF1FF] text-[#8E24AA] border-[#8E24AA]/30'
                            : 'bg-white text-[#909090] border-[#EDEDED] hover:border-[#8E24AA]/30'}
          `}
                >
                    <Filter className="w-3 h-3" />
                    Solo no leídas
                </button>
            </div>

            {/* Lista */}
            {loading ? (
                <div className="flex flex-col gap-3">
                    {[...Array(4)].map((_, i) => (
                        <div key={i} className="h-20 rounded-xl bg-[#F9F9F9] animate-pulse" />
                    ))}
                </div>
            ) : filtradas.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 text-center">
                    <div className="w-12 h-12 rounded-full bg-[#F9F9F9] flex items-center justify-center mb-3">
                        <Bell className="w-5 h-5 text-[#EDEDED]" />
                    </div>
                    <p className="text-sm text-[#909090]">No hay notificaciones</p>
                </div>
            ) : (
                <div className="flex flex-col gap-2">
                    {filtradas.map(n => (
                        <NotificacionItem
                            key={n.id}
                            notificacion={n}
                            onMarcarLeida={marcarLeida}
                            onArchivar={archivar}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}